import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import UpdateProfile from './UpdateProfile';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading,
    data,
    error,
    message,
    updatedUser,
  } = state.user;
  return {
    isLoading,
    data,
    error,
    message,
    updatedUser,
  };
}

const Styled = withStyles(styles)(UpdateProfile);

export default connect(
  mapStateToProps,
)(Styled);
